import { render, staticRenderFns } from "./SkillsPanel.vue?vue&type=template&id=73461c3e&"
import script from "./SkillsPanel.vue?vue&type=script&lang=js&"
export * from "./SkillsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports